import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "creationV2__header" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  class: "w-10 h-10 border rounded-full border-creation-on-primary/creation-circle1 object-cover shrink-0",
  src: "/assets/img/avatar-square.jpg",
  alt: "Avatar"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "w-10 h-10 border rounded-full border-creation-on-primary/creation-circle1 object-cover shrink-0",
  src: "/assets/img/avatar-square.jpg",
  alt: "Avatar"
}
const _hoisted_6 = { class: "flex-1 text-creation-on-background font-semibold truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NetworkImageComponent = _resolveComponent("NetworkImageComponent")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    (_ctx.campaign.profile.brandLink)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.campaign.profile.brandLink,
          target: "_blank"
        }, [
          (_ctx.image)
            ? (_openBlock(), _createBlock(_component_NetworkImageComponent, {
                key: 0,
                class: "w-10 h-10 border rounded-full border-creation-on-primary/creation-circle1 object-cover shrink-0",
                image: _ctx.image,
                width: 300,
                height: 300
              }, null, 8, ["image"]))
            : (_openBlock(), _createElementBlock("img", _hoisted_3))
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.image)
            ? (_openBlock(), _createBlock(_component_NetworkImageComponent, {
                key: 0,
                class: "w-10 h-10 border rounded-full border-creation-on-primary/creation-circle1 object-cover shrink-0",
                image: _ctx.image,
                width: 300,
                height: 300
              }, null, 8, ["image"]))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ])),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.campaign.profile.name || _ctx.campaign.profile.url), 1)
  ]))
}